import AssociateWallet from '../components/AssociateWallet'
import ChangePassword from '../components/ChangePassword'
import ChangePasswordSuccess from '../components/ChangePasswordSuccess'
import ForgotPassword from '../components/ForgotPassword'
import LoginScreen from '../components/LoginScreen'
import RegisterScreen from '../components/RegisterScreen'
import VerifyEmail from '../components/VerifyEmail'
import VerifyEmailSuccess from '../components/VerifyEmailSuccess'
import Disclaimer from '../pages/Disclaimer'
import NotFound from '../pages/elements/404'
import HomeStartUp from '../pages/HomeStartUp'
import Privacy from '../pages/Privacy'
import Profile from '../pages/Profile'
import Terms from '../pages/Terms'

export const routes = [
  {
    path: '/',
    name: 'HomeStartUp',
    component: HomeStartUp,
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: Disclaimer,
  },
  {
    path: '/terms',
    name: 'Terms & Conditions',
    component: Terms,
  },
  {
    path: '/privacy',
    name: 'Privacy Policy',
    component: Privacy,
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginScreen,
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterScreen,
  },
  {
    path: '/verify',
    name: 'Verify Email',
    component: VerifyEmail,
  },
  {
    path: '/verify-success',
    name: 'Email Successfully Verified',
    component: VerifyEmailSuccess,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
  },
  {
    path: '/change-password-success',
    name: 'Password Successfully Changed',
    component: ChangePasswordSuccess,
  },
  {
    path: '/associate-wallet',
    name: 'Connect & Associate Wallet',
    component: AssociateWallet,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
]
